import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { get } from "lodash";

import { MALUS_STATUS } from "~/entity/Appeals/model/schema";
import {
  IAppealPeriodShema,
  IAppealSchema,
} from "~/entity/Appeals/model/schema";
import { AppealStatusFrontendController } from "~/pages/Appeal/ui/TableCellComponents/AppealStatusFrontendController";
import { ResolutionStatusFrontendController } from "~/pages/Appeal/ui/TableCellComponents/ResolutionStatusFrontendController";
import { RoundMini } from "~/shared/ui/StatusMarker/RoundMini";

export const getAppealsColumns = (
  t: TFunction,
  options: readonly string[],
  periodsData: IAppealPeriodShema[],
  handlers: {
    onOpenFilesModal: (id: string | number) => () => void;
    onOpenAddAppealModal: (id: string | number) => () => void;
    onOpenResolveAppealModal: (id: string | number) => () => void;
    onOpenAppealCommentModal: (id: string | number) => () => void;
    onOpenEditorAppealModal: (id: string | number) => () => void;
  },
): ColumnsType<IAppealSchema> =>
  options.map((option) => {
    const dataIndex = option.includes(".") ? option.split(".") : option;
    const title = t(`appeal.${option}`);

    if (option === "malusStatusFrontend") {
      return {
        title,
        dataIndex,
        key: option,
        render: (value: any) => {
          let status: "appealStarted" | "good" | "bad" =
            MALUS_STATUS.appealStarted;
          switch (value) {
            case false:
              status = "good";
              break;
            case true:
              status = "bad";
              break;
          }
          return <RoundMini status={status} />;
        },
      };
    }

    if (option === "appealStatusFrontend") {
      return {
        title,
        dataIndex,
        key: option,
        render: (value: any, record: IAppealSchema) => (
          <AppealStatusFrontendController
            files={record.files}
            value={value}
            malusStatus={record.malusStatusFrontend}
            resolutionStatus={record.resolutionStatusFrontend}
            onOpenFilesModal={handlers.onOpenFilesModal(record.id)}
            onOpenAddAppealModal={handlers.onOpenAddAppealModal(record.id)}
            periodsData={periodsData}
          />
        ),
      };
    }

    if (option === "resolutionStatusFrontend") {
      return {
        title,
        dataIndex,
        key: option,
        render: (value: any, record: IAppealSchema) => (
          <ResolutionStatusFrontendController
            status={record.resolutionStatusFrontend}
            appealStatus={record.appealStatusFrontend}
            onOpenResolveAppealModal={handlers.onOpenResolveAppealModal(
              record.id,
            )}
            onOpenAppealCommentModal={handlers.onOpenAppealCommentModal(
              record.id,
            )}
            onOpenEditorAppealModal={handlers.onOpenEditorAppealModal(
              record.id,
            )}
            appealId={record.id}
          />
        ),
      };
    }

    return {
      title,
      dataIndex,
      key: option,
      render: (value: any, record: IAppealSchema) => (
        <span>{get(record, option, "-")}</span>
      ),
    };
  });
